export default "__VITE_ASSET__DZdNyaMm__"